/** タググループとTailwind背景クラスのマッピング */
const TAG_GROUP_COLORS: Record<string, string> = {
  role: 'bg-amber-500',
  skill: 'bg-lime-600',
  cert: 'bg-teal-700',
  state: 'bg-orange-600',
  class: 'bg-purple-700',
  site: 'bg-stone-500',
  prop: 'bg-blue-600',
  stage: 'bg-cyan-500',
  improvement: 'bg-pink-700',
  undefined: 'bg-slate-400',
  default: 'bg-gray-300',
}

/**
 * タググループの説明ラベル
 */
export const TAG_GROUP_LABELS: Record<string, string> = {
  role: '役割',
  state: '状態',
  skill: 'スキル',
  class: '職級グループ',
  site: '勤務場所',
  prop: '個人属性',
  cert: '資格',
  stage: '工程',
  improvement: '改善候補',
}

/**
 * タグ名からグループを解析
 * タグ名は「group:name」形式（例: skill:React）
 * @param tagName タグ名
 * @returns { group, name, displayName }
 */
export function parseTagName(tagName: string): { group: string | null; name: string; displayName: string } {
  // null/undefinedチェック
  if (!tagName) {
    return {
      group: null,
      name: '',
      displayName: '',
    }
  }
  const match = tagName.match(/^([a-z]+):(.+)$/)
  if (match?.[1] && match[2]) {
    return {
      group: match[1],
      name: match[2],
      displayName: `${match[1]}:${match[2]}`,
    }
  }
  return {
    group: null,
    name: tagName,
    displayName: tagName,
  }
}

/**
 * タグ名からTailwindカラークラスを取得
 * @param tagName タグ名
 * @returns Tailwindカラークラス（例: bg-amber-500）
 */
export function getTagColorClass(tagName: string): string {
  if (!tagName) return TAG_GROUP_COLORS.undefined as string
  const { group } = parseTagName(tagName)
  return getTagGroupColor(group)
}

/**
 * タググループからTailwind背景クラスを取得
 * @param group グループ名（null の場合は undefined 色）
 * @returns Tailwind背景クラス（例: bg-amber-500）
 */
export function getTagGroupColor(group: string | null): string {
  if (!group) return TAG_GROUP_COLORS.undefined as string
  return TAG_GROUP_COLORS[group] ?? (TAG_GROUP_COLORS.default as string)
}
